import { Box, Chip, styled, Typography } from "@mui/material";

export const StyledUsers = {
  StyledChip: styled(Chip)({
    margin: "2px 4px",
    fontSize: "0.75rem",
    height: 24,
  }),
  EmptyText: styled(Typography)({
    fontSize: "0.85rem",
    color: "rgba(0, 0, 0, 0.5)",
    fontStyle: "Roboto, sans-serif !important",
  }),
  ProviderContainer: styled(Box)({
    backgroundColor: "#f9f9f9",
    padding: "10px 15px",
    borderRadius: 4,
    boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
  }),
  ArtList: styled(Typography)({
    fontSize: "0.8rem",
    color: "#333",
  }),
  TableContainer: styled(Box)({
    overflow: "hidden", // Elimina el scroll visible
    position: "relative", // Requerido para ocultar el scroll
  }),
  ScrollContainer: styled(Box)({
    overflowY: "auto", // Permite desplazamiento vertical
    overflowX: "hidden", // Evita desplazamiento horizontal
    height: "100%", // Asegura que tome todo el espacio disponible
  }),
};
